
import { Component, Vue, Prop } from 'vue-property-decorator';
import VButton from '../VButton.vue';

@Component({
  components: {
    VButton,
  },
})
export default class UploadButton extends Vue {
  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ default: '' }) accept!: string;

  @Prop({ default: false }) multiple!: boolean;

  @Prop({ default: '' }) buttonClass!: any;

  private get buttonEvents() {
    let clickListeners: Function[] = [];
    if (this.$listeners.click) {
      clickListeners = Array.isArray(this.$listeners.click) ? this.$listeners.click : [this.$listeners.click];
    }

    return {
      ...this.$listeners,
      click: [this.showUpload, ...clickListeners],
    };
  }

  private onFileSelection() {
    this.$emit('files-selected', this.$refs.input.files || []);

    this.$refs.input.value = '';
  }

  private onClick() {}
  showUpload() {
    this.$refs.input.dispatchEvent(
      new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      })
    );
  }
}
